/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import { connect } from "react-redux";
import "./OffreDetail.scss";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import Modal from "Components/Modal/Modal";
import Loader from "Components/Loader/loader";
import { InputTextarea } from "primereact/inputtextarea";
import { FileUpload } from "primereact/fileupload";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Toast } from "primereact/toast";
import {
  FaChevronLeft,
  FaRegBuilding,
  FaWheelchair,
  FaDownload,
} from "react-icons/fa";
import { IoMdDesktop, IoMdHome } from "react-icons/io";
import { BsHouseDoor, BsPeople } from "react-icons/bs";
import image from "../../../../assets/offre1.webp";
import { updateAuth } from "Redux/Actions/authActions";
import { Checkbox } from "primereact/checkbox";
import diffuseur_logo from "assets/diffuseur_logo.png";
import img_groupe1 from "assets/logoOffre1.webp";
import parse from "html-react-parser";
import GestionDepotOffreActions from "Components/Offres/GestionDepotOffre/GestionDepotOffreActions/GestionDepotOffreActions";
import { fetchPost } from "Services/api";

const OffreDetail = (props) => {
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];

  const uploadOptions = {
    label: " ",
    icon: "pi pi-check",
    className: "bouton_valider",
  };
  const cancelOptions = {
    label: " ",
    icon: "pi pi-times",
    className: "bouton_supprimer",
  };
  const uploadToast = useRef(null);
  const cancelToast = useRef(null);
  const [visibleModalPostuler, setVisibleModalPostuler] = useState(false);
  const [visibleModalPostulerRapide, setVisibleModalPostulerRapide] =
      useState(false);

  const [loaderIsVisible, setLoaderIsVisible] = useState(false);
  const [offre, setOffre] = useState();
  const [isOfferSaved, setIsOfferSaved] = useState();
  const [message, setMessage] = useState("");
  const [cvCheckbox, setCvCheckbox] = useState(true);
  const [dowloadedResume, setDownloadedResume] = useState(null);
  const [RPResume, setRPResume] = useState(null);
  const toast = useRef(null);
  const [isEditable, setIsEditable] = useState(false);

  let id = props.id ? props.id : useParams().id;

  const reset = () => {
    setMessage("");
    setCvCheckbox(true);
    setDownloadedResume(null);
    setVisibleModalPostuler(false);
  };

  const getCandidatures = async () => {
    let responseData = null;
    const url = `${process.env.REACT_APP_BASE_URL_API}/candidatures/user/${props.auth.userConnected.id}`;
    try {
      let response = await axios.get(url, {
        headers: props.auth.token
            ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
            : {
              accept: "application/json",
            },
      });
      responseData = response.data;
    } catch (error) {
      console.log(error);
      responseData = null;
    }
    return responseData;
  };
  // Va chercher dans la base l'offre que l'on veut afficher
  const getOffer = () => {
    axios
        .get(`${process.env.REACT_APP_BASE_URL_API}/offers/${id}`, {
          headers: props.auth.token
              ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
              : {
                accept: "application/json",
              },
        })
        .then(function (response) {
          setLoaderIsVisible(false);
          setOffre(response.data);
          setIsOfferSaved(
              props.auth.userConnected.savedOffers.filter(
                  (offer) => offer.id === response.data.id
              ).length > 0
          );
          if (
              props.auth.isAdmin ||
              response.data.id === props.auth.userConnected.id
          )
            setIsEditable(true);
        })
        .catch(function (error) {
          console.log(error);
        });
  };

  //  Useeffect de chargement
  useEffect(() => {
    setLoaderIsVisible(true);
    getOffer();
  }, []);

  useEffect(() => {
    // Si la carte est modifiée depuis le depot d'offre on affiche sa nouvelle valeur dans le détail
    if (props.offers?.dataFromPagination?.data) {
      const newOffer = props.offers.dataFromPagination.data.filter(
          (offer) => offer.id == id
      );
      newOffer.length > 0 && setOffre(newOffer[0]);
    }
  }, [props.offers?.dataFromPagination?.data]);

  const downloadRPResume = () => {
    let url = `${process.env.REACT_APP_BASE_URL_API}/cvs/${props.auth.userConnected.id}/pdf`;
    axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${props.auth.token}`,
            accept: "application/json",
          },
          responseType: "blob",
        })
        .then((res) => {
          setRPResume(URL.createObjectURL(res.data));
        })
        // Si il y a une erreur, on l'affiche dans la console
        .catch((error) => {
          console.log(error.message);
        });
  };

  // Fonction de validation de la candidature
  const accept = async () => {
    const data = {
      user: "/api/users/" + props.auth.userConnected.id,
      dateOfCandidature: new Date(),
      offer: "api/offers/" + id,
      message: message,
    };
    if (offre.transmitter === "Recruteur") {
      if (dowloadedResume !== null) {
        data.document = dowloadedResume;
      } else if (cvCheckbox) {
        data.resumeReseauPro = true;
      } else {
        data.extraResumeFilePath = props.auth.userConnected.resume.contentUrl;
      }
    }

    // Si on a déjà cliqué sur postuler on n'ajoute pas de nouvelle candidature
    const candidatureData = await getCandidatures();
    if (
        candidatureData.some(
            (candidature) =>
                candidature.user.split("/")[3] == props.auth.userConnected.id &&
                candidature.offer.split("/")[3] == offre.id
        )
    )
      return;

    let url = `${process.env.REACT_APP_BASE_URL_API}${"/candidature/apply"}`;
    var dataForm = new FormData();
    for (var key in data) dataForm.append(key, data[key]);
    // On envoie le formData au serveur
    axios
        .post(url, dataForm, {
          headers: props.auth.token
              ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
              : {
                accept: "application/json",
              },
        })
        .then(() => {
          offre.transmitter === "Recruteur" &&
          toast.current.show({
            severity: "success",
            summary: "Validé",
            detail: "Vous avez postulé",
            life: 3000,
          });
          reset();
        })
        // Si il y a une erreur, on l'affiche dans la console
        .catch((error) => console.log(error.message));
  };

  // Ajoute l'offre aux offres sauvegardées
  const addOfferToSaveList = () => {
    const url = `${process.env.REACT_APP_BASE_URL_API}/offers/${offre.id}/save`;
    const data = { savedByUsers: [`api/users/${props.auth.userConnected.id}`] };
    axios
        .post(url, data, {
          headers: props.auth.token
              ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
              : {
                accept: "application/json",
              },
        })
        .then((res) => {
          setIsOfferSaved(true);
          let user = props.auth.userConnected;
          user.savedOffers = user.savedOffers.concat(res.data);
          props.handleAuth({
            userConnected: user,
          });
        })
        .catch((error) => {
          console.log("Error modify : ", error.response);
        });
  };

  // Retire l'offre des offres sauvegardées
  const removeOfferFromSaveList = () => {
    const url = `${process.env.REACT_APP_BASE_URL_API}/offers/${offre.id}/erase`;
    const data = { savedByUsers: [`api/users/${props.auth.userConnected.id}`] };
    axios
        .post(url, data, {
          headers: props.auth.token
              ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
              : {
                accept: "application/json",
              },
        })
        .then((res) => {
          setIsOfferSaved(false);
          let user = props.auth.userConnected;
          (user.savedOffers = user.savedOffers.filter(
              (saved) => saved.id !== res.data.id
          )),
              props.handleAuth({
                userConnected: user,
              });
        })
        .catch((error) => {
          console.log("Error modify : ", error);
        });
  };

  // Gestion de la pop-up de confirmation
  const [disableRP, setDisableRP] = useState(false);
  const [disableOwn, setDisableOwn] = useState(
      props.auth.userConnected.resume.contentUrl === null
  );
  const uploadHandler = ({ files }) => {
    setDisableOwn(true);
    setDisableRP(true);
    setDownloadedResume(files[0]);
    uploadToast.current.show({
      severity: "success",
      summary: "Succès : ",
      detail: "Le fichier a bien été téléchargé",
      life: 3000,
    });
  };

  const findLogo = (offre) => {
    const logo = offre.university?.imageTransparentAndColorUrl;
    switch (offre.transmitter?.name) {
      case "Diffuseur":
        return props.secondaryTables.transmittersData
            ? props.secondaryTables.transmittersData.find(
                (transmitter) => transmitter.name == "Diffuseur"
            ).imageUrl
            : API_LINK + logo;
      case "Admin":
        return props.secondaryTables.transmittersData
            ? props.secondaryTables.transmittersData.find(
                (transmitter) => transmitter.name == "Admin"
            ).imageUrl
            : API_LINK + logo;
      case "Etudiant":
        return API_LINK + logo;
      case "Université":
        return API_LINK + logo;
      case "Personnel":
        return API_LINK + logo;
      case "Alumni":
        return API_LINK + logo;
      case "Recruteur":
        return API_LINK + (offre?.company?.logoLink || logo);
      default:
        return img_groupe1;
    }
  };

  /**
   * Envoie une requête au serveur pour augmenter le nombre de clics sur le bouton "Postuler"
   * pour l'offre actuelle
   */
  const sendApplyButtonClickedRequest = async () => {
    try {
      await fetchPost(
          `/offers/${id}/increaseApplyClickCount`,
          {},
          props.auth?.token
      );
    } catch (error) {
      console.log("Error increasing apply click count : ", error);
    }
  };

  return (
      <div>
        <Toast ref={uploadToast} />
        <Toast ref={cancelToast} />
        {!props.id && <Header />}
        {loaderIsVisible ? (
            <Loader />
        ) : (
            props.auth.isConnected &&
            offre && (
                <div className="offre_detail_container">
                  <Toast ref={toast} />
                  {!props.id && (
                      <div className="offre_detail_container__title">
                        <h1 className="h1_trait_dessus">Détail de l&apos;offre</h1>
                        <BtnBlanc
                            btnTexte="Revenir aux offres"
                            btnIcone={<FaChevronLeft />}
                            btnAction={() => window.history.back()}
                        />
                      </div>
                  )}
                  <div className="offre_detail_container__offre">
                    <div className="offre_detail_container__offre__background">
                      {offre?.imageUrl ? (
                          <img src={offre?.imageUrl} alt="Fond actualité" />
                      ) : (
                          <img src={image} alt="Fond actualité" />
                      )}
                    </div>
                    <div className="offre_detail_container__offre__top">
                      <div className="offre_detail_container__offre__top__logo">
                        <img
                            className="offre_detail_container__offre__top__logo-img"
                            src={findLogo(offre)}
                            alt="Logo entreprise"
                            title="Logo entreprise"
                        />
                      </div>
                      {isEditable && (
                          <div className="offre_detail_container__offre__top__buttons">
                            <GestionDepotOffreActions
                                statut={offre.state}
                                id={offre.id}
                                offre={offre}
                                feedback={offre.feedback?.feedback}
                                secondClass="desktop"
                            ></GestionDepotOffreActions>
                          </div>
                      )}
                    </div>

                    <div className="offre_detail_container__offre__description">
                      <p className="offre_detail_container__offre__description__title--main">
                        <a href={offre.urlCompany}>{offre.companyName}</a>
                        <span className="offre_detail_container__offre__description__title--main__offre">{` - ${offre.title}`}</span>
                      </p>
                      <div className="offre_detail_container__offre__description__infoEntreprise">
                        <ul className="offre_detail_container__offre__description__infoEntreprise__list">
                          <li className="offre_detail_container__offre__description__infoEntreprise__list__item">
                            <FaRegBuilding />{" "}
                            {offre.company
                                ? offre.company.structure
                                    ? offre.company.structure.label
                                    : offre.company.type.label
                                : "Non renseigné"}
                          </li>
                          <li className="offre_detail_container__offre__description__infoEntreprise__list__item">
                            <BsPeople />{" "}
                            {offre.company?.totalStaff
                                ? offre.company.totalStaff.label
                                : "Non renseigné"}
                          </li>
                          {offre?.sector && (
                              <li className="offre_detail_container__offre__description__infoEntreprise__list__item">
                                <BsHouseDoor /> {offre?.sector?.label}
                              </li>
                          )}
                        </ul>
                      </div>
                      {offre.domains != null && (
                          <p className="offre_detail_container__offre__description__title">
                            {offre.domains.length > 1 ? "Domaines" : "Domaine"} de
                            l&apos;offre : <br />
                            <span>
                      {offre.domains.map((domain) => (
                          <React.Fragment key={domain.label}>
                            {domain.label}
                            {offre.domains.indexOf(domain) !==
                            offre.domains.length - 1
                                ? ", "
                                : ""}
                          </React.Fragment>
                      ))}{" "}
                    </span>
                          </p>
                      )}
                      <p className="offre_detail_container__offre__description__title">
                        Catégorie de contrat de l&apos;offre :{" "}
                        <span>{offre.offerCategory.label}</span>
                      </p>
                      <p className="offre_detail_container__offre__description__title">
                        Type de contrat de l&apos;offre :{" "}
                        <span>
                    {offre.typeOfContract?.label
                        ? offre.typeOfContract?.label
                        : offre.offerCategory.label}
                  </span>
                      </p>
                      {offre?.levelOfEducations[0] !== undefined && (
                          <p className="offre_detail_container__offre__description__title">
                            {offre.levelOfEducations.length > 1 ? "Niveaux" : "Niveau"}{" "}
                            d&apos;études : <br />
                            <span>
                      {offre.levelOfEducations.map((level) => (
                          <>
                            {level.label}
                            {offre.levelOfEducations.indexOf(level) !==
                            offre.levelOfEducations.length - 1
                                ? ", "
                                : ""}
                          </>
                      ))}{" "}
                    </span>
                          </p>
                      )}
                      <p className="offre_detail_container__offre__description__title">
                        Lieu de l&apos;offre :{" "}
                        <span>
                    {offre.country} - {offre.department} - {offre.city}
                  </span>
                      </p>
                      {!offre.minSalary && !offre.maxSalary && offre.gratification ? (
                          <p className="offre_detail_container__offre__description__title">
                            Gratification : <span>{offre.gratification}</span>
                          </p>
                      ) : (
                          <p className="offre_detail_container__offre__description__title">
                            Tranche de salaire :{" "}
                            <span>
                      {offre.minSalary} € - {offre.maxSalary} €
                    </span>
                          </p>
                      )}
                      <p className="offre_detail_container__offre__description__titleWithMarge">
                        Description de l&apos;entreprise ou du service
                      </p>
                      <p className="offre_detail_container__offre__description__text">
                        {offre.companyDescription && parse(offre.companyDescription)}
                      </p>
                      <p className="offre_detail_container__offre__description__titleWithMarge">
                        Description de l&apos;offre
                      </p>
                      <p className="offre_detail_container__offre__description__text">
                        {parse(offre.description)}
                      </p>
                      {offre.experience && (
                          <>
                            <p className="offre_detail_container__offre__description__titleWithMarge">
                              Description du profil recherché
                            </p>
                            <p className="offre_detail_container__offre__description__text">
                              {parse(offre.experience)}
                            </p>
                          </>
                      )}
                    </div>
                    <div className="offre_detail_container__offre__description__bottom">
                      <div className="offre_detail_container__offre__description__bottom--right">
                        <p className="offre_detail_container__offre__description__title">
                          INFORMATIONS COMPLEMENTAIRES :
                        </p>
                        {(!offre.accessibleForDisabled ||
                            !offre.remoteWorking ||
                            !offre.accommodation) && (
                            <p className="offre_detail_container__offre__description__title">
                              Non renseigné
                            </p>
                        )}
                        {offre.accessibleForDisabled && (
                            <p className="offre_detail_container__offre__description__title">
                              <FaWheelchair /> Poste handi-accueillant
                            </p>
                        )}
                        {offre.remoteWorking && (
                            <p className="offre_detail_container__offre__description__title">
                              <IoMdDesktop /> Télétravail possible
                            </p>
                        )}
                        {offre.accommodation && (
                            <p className="offre_detail_container__offre__description__title">
                              <IoMdHome /> Hébergement possible
                            </p>
                        )}
                      </div>
                    </div>
                    <div className="offre_detail_container__boutons">
                      {
                        <BtnBleu
                            btnTexte="Postuler"
                            btnAction={async () => {
                              await sendApplyButtonClickedRequest();
                              if (offre.transmitter === "Recruteur") {
                                setVisibleModalPostuler(!visibleModalPostuler);
                              } else {
                                setVisibleModalPostulerRapide(
                                    !visibleModalPostulerRapide
                                );
                                accept();
                              }
                              downloadRPResume();
                            }}
                        />
                      }
                      {visibleModalPostulerRapide && (
                          <Modal
                              visible={visibleModalPostulerRapide}
                              setVisible={setVisibleModalPostulerRapide}
                              header="Vous souhaitez postuler à cette offre "
                          >
                            <div className="modal_contact_candidature_rapide">
                              {offre.contacts.map((contact, index) => (
                                  <>
                                    {contact.email && (
                                        <a href={`mailto:${contact?.email}`}>
                                          <p>Par mail :</p>
                                          <span>{contact?.email}</span>
                                        </a>
                                    )}
                                    {contact.phone && (
                                        <a href={`tel:${offre.contacts[0]?.phone}`}>
                                          <p>Par téléphone :</p>
                                          <span>{contact?.phone}</span>
                                        </a>
                                    )}
                                  </>
                              ))}
                              {offre.companyUrl && (
                                  <a
                                      href={
                                          offre.companyUrl.includes("http") &&
                                          offre.companyUrl
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                  >
                                    <p>Depuis le site de l&apos;entreprise :</p>
                                    <span>{offre.companyUrl}</span>
                                  </a>
                              )}
                              {offre.urlCandidature && (
                                  <a
                                      href={
                                          offre.urlCandidature.includes("http") &&
                                          offre.urlCandidature
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                  >
                                    <p>Depuis le lien de l&apos;offre :</p>
                                    <span>{offre.urlCandidature}</span>
                                  </a>
                              )}
                            </div>
                          </Modal>
                      )}
                      {visibleModalPostuler && (
                          <Modal
                              visible={visibleModalPostuler}
                              setVisible={setVisibleModalPostuler}
                              header="Vous souhaitez postuler à cette offre "
                          >
                            <div className="description__postulate">
                              {/* Message au recruteur */}
                              <p className="message_recruteur">
                                {"Transmettez un message au recruteur (facultatif) :"}
                              </p>
                              <InputTextarea
                                  className="text-area-pop-in"
                                  onChange={(e) => {
                                    setMessage(e.target.value);
                                  }}
                              />
                              {/* Checkbox de choix de CV */}
                              <p className="message_recruteur">
                                {"Vous devez choisir un CV pour candidater :"}
                              </p>
                              <div className="checkbox_RP">
                                <Checkbox
                                    id="cb1"
                                    onChange={(e) =>
                                        !disableOwn && setCvCheckbox(e.checked)
                                    }
                                    checked={disableRP ? false : cvCheckbox}
                                    value="test"
                                    disabled={disableRP}
                                ></Checkbox>
                                <span>{" Utiliser le CV Réseau Alumni"}</span>
                              </div>
                              <div className="checkbox_Own">
                                <Checkbox
                                    id="cb1"
                                    onChange={(e) => setCvCheckbox(!e.checked)}
                                    checked={disableOwn ? false : !cvCheckbox}
                                    disabled={disableOwn}
                                ></Checkbox>
                                <span>
                          {props.auth.userConnected.resume.contentUrl
                              ? " Utiliser le CV importé dans mon profil"
                              : " Utiliser le CV importé dans mon profil (indisponible)"}
                        </span>
                              </div>
                              {/* Téléchargement d'un CV externe */}
                              <div className="download">
                                <FaDownload className="upload_icone"></FaDownload>
                                <FileUpload
                                    className="download_CV"
                                    customUpload={true}
                                    uploadOptions={uploadOptions}
                                    cancelOptions={cancelOptions}
                                    uploadHandler={uploadHandler}
                                    chooseLabel="Importer un CV depuis mon PC"
                                    onClear={() => {
                                      setDisableOwn(
                                          props.auth.userConnected.resume.contentUrl ===
                                          null
                                      );
                                      setDisableRP(false);
                                      setDownloadedResume(undefined);
                                      cancelToast.current.show({
                                        severity: "error",
                                        summary: "Suppression : ",
                                        detail: "Le fichier a bien été supprimé",
                                        life: 3000,
                                      });
                                    }}
                                    accept="application/pdf"
                                    maxFileSize={1000000}
                                ></FileUpload>
                              </div>

                              {/* Bouton candidater et annuler */}
                              <div className="postulate_buttons">
                                <button
                                    className="btn-bleu"
                                    name="Candidater"
                                    onClick={() => accept()}
                                >
                                  Candidater
                                </button>
                                <BtnBlanc
                                    btnTexte="Annuler"
                                    btnAction={() => {
                                      reset();
                                    }}
                                />
                              </div>

                              <ConfirmPopup />
                            </div>
                          </Modal>
                      )}
                      {isOfferSaved ? (
                          <BtnBleu
                              btnTexte="Retirer des offres sauvegardéees"
                              btnAction={() => {
                                removeOfferFromSaveList();
                              }}
                          ></BtnBleu>
                      ) : (
                          <BtnBlanc
                              btnTexte="Sauvegarder l'offre"
                              btnAction={() => {
                                addOfferToSaveList();
                              }}
                          ></BtnBlanc>
                      )}
                    </div>
                  </div>
                </div>
            )
        )}
        {!props.id && <Footer />}
      </div>
  );
};

OffreDetail.propTypes = {
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
  adminAuth: PropTypes.func,
  offers: PropTypes.object,
  id: PropTypes.number,
  secondaryTables: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  offers: state.offers,
  secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = (dispatch) => ({
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OffreDetail);
